import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DriverImageClientData } from '../../driver/models/driver-image-model';
import { BaseService } from '../../shared/base-service/base.service';
import { BusinessTransactionOverrideModel } from '../../shared/models/business-transaction/business-transaction-override.model';
import { AppSettings } from '../../shared/settings/app-settings.model';

@Injectable()
export class CustomerImageOOJService extends BaseService<AppSettings.HelpDeskSettings> {
    constructor() {
        super(s => s.helpDesk);
        if (this.serviceSettings) {
            this.serviceUrl = this.serviceSettings.integrationServiceUrl;
        }
    }

    public startDriverImageRequest(model: { SelectedCustomerPdps: any[]; BusinessTransactionId: number }): Observable<{ result: boolean }> {
        return this.post('AIS/PDPS/Request/DriverImageRequest', model);
    }

    public getDriverImage(jurisdictionCode: string, credentialNumber: string): Observable<{ result: string }> {
        return this.get(`AIS/PDPS/Request/DriverImage/${jurisdictionCode}/${credentialNumber}`);
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }
        return value;
    }
}
